import type { ReapproProductPreview } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchReapproCategoryPreview = async (storeId: number, categoryId: number) => {
  const response = await gozokiApiWithAuth.get<{ products: ReapproProductPreview[] }>(
    `/stores/${storeId}/reappro-categories/${categoryId}/preview`,
  )
  return response.data.products
}
